var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8-3h45v45H-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0021B",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M14 1C6.813 1 1 6.79 1 13.95 1 23.663 14 38 14 38s13-14.337 13-24.05C27 6.79 21.187 1 14 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    d: "M14 18.575c-2.563 0-4.643-2.072-4.643-4.625S11.437 9.325 14 9.325c2.563 0 4.643 2.072 4.643 4.625s-2.08 4.625-4.643 4.625z"
  }))));
}

export default SvgMarker;